import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { ExperienceWorkflowWithContext } from '@ply-io/ply-front-shared-utilities';
import { useInject } from '@/components/SideBar/composables';
import { TileContextMenuFunctionsInterface, TileContextMenuFunctionsKey } from '../../types';
import { useWorkflowPermissions } from '@/composables';
interface TileDropdownMainMenuProps {
	workflow: ExperienceWorkflowWithContext;
}
interface MenuItem {
	text: string;
	iconName: string;
	onClick: () => void;
	hidden: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TileDropdownMainMenu',
  props: {
    workflow: null
  },
  emits: ["option-clicked"],
  setup(__props: any, { emit }: { emit: ({ (e: 'option-clicked'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
	workflow: ExperienceWorkflowWithContext;
}




const workflow = computed(() => props.workflow);
const { canEditWorkflow, canDeleteWorkflow, canEditGeneralConfiguration } = useWorkflowPermissions(workflow.value.id);

const { deleteWorkflow, openShareWorkflow, openEditSetup, editWorkflow, editButtonStyle } =
	useInject<TileContextMenuFunctionsInterface>(TileContextMenuFunctionsKey);
const isInstalledFrom = computed<boolean>(() => !!workflow.value.installed_from);
const isPublished = computed<boolean>(() => workflow.value.is_published);
const isSharingBlocked = computed<boolean>(() => !canEditWorkflow || !isPublished.value);
const userSetupId = computed(() => workflow.value.current_version_user_setup);
const generalSetupId = computed(() => workflow.value.current_version_general_setup);
const hasUserSetup = computed<boolean>(() => !!userSetupId.value);
const hasGeneralSetup = computed<boolean>(() => !!generalSetupId.value);
const flowNeedsSetup = computed(
	() => isInstalledFrom.value || hasUserSetup.value || (hasGeneralSetup.value && canEditGeneralConfiguration)
);

const menuItems = computed<MenuItem[]>(() => [
	{
		text: `Edit ${workflow.value.current_draft.ui_element.type} design`,
		iconName: 'edit-button-design',
		onClick: () => editButtonStyle(workflow.value.id),
		hidden: !canEditWorkflow,
	},
	{
		text: 'Edit feature',
		iconName: 'edit-feature',
		onClick: () => editWorkflow(workflow.value.id, workflow.value.project),
		hidden: !canEditWorkflow || isInstalledFrom.value,
	},
	{
		text: 'Share',
		iconName: 'share-feature',
		hidden: isSharingBlocked.value,
		onClick: () => openShareWorkflow(workflow.value.id),
	},
	{
		text: 'Setup',
		iconName: 'setup-feature',
		hidden: !flowNeedsSetup.value,
		onClick: () => openEditSetup(workflow.value.id),
	},
	{
		text: 'Delete',
		hidden: !canDeleteWorkflow,
		iconName: 'delete-feature',
		onClick: () => deleteWorkflow(workflow.value.id),
	},
]);
const relevantMenuItems = computed(() => menuItems.value.filter((item) => !item.hidden));

return { __sfc: true,props, emit, workflow, canEditWorkflow, canDeleteWorkflow, canEditGeneralConfiguration, deleteWorkflow, openShareWorkflow, openEditSetup, editWorkflow, editButtonStyle, isInstalledFrom, isPublished, isSharingBlocked, userSetupId, generalSetupId, hasUserSetup, hasGeneralSetup, flowNeedsSetup, menuItems, relevantMenuItems }
}

})